import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

const FooterCard11 = () => {
  return (<>
    <footer className="sports-footer-fc-11">
      {/* Angled Top Orange Shapes */}
      <div className="footer-fc-11-orange-left"></div>
      <div className="footer-fc-11-orange-right"></div>

<h2 >Vision Classes</h2>
      <div className="footer-fc-11-content">

        {/* Column 1 - Logo + About */}
        <div className="footer-fc-11-col">
       
          <p className="footer-fc-11-text">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Excepteur sint occaecat
            cupidatat non proident sunt in culpa.
          </p>

         
         
        </div>

        {/* Column 2 - Contact Info */}
        <div className="footer-fc-11-col">
          <h3 className="footer-fc-11-heading">CONTACT INFO</h3>

          <p className="footer-fc-11-item">Address: Lorem ipsum dolor sit</p>
          <p className="footer-fc-11-item">Email: info@sports.com</p>
          <p className="footer-fc-11-item">Phone: 123456789</p>
        </div>

        {/* Column 3 - Popular News */}
        <div className="footer-fc-11-col">
         <div className="social-fc-11-row">
                     <div className="social-fc-11-icons"><h3 >MY SOCIAL PROFILE</h3></div> 
                     <div className="social-fc-11-icons">
                       <span><FaFacebookF />
                                 </span>
                       <span>  <FaTwitter />
                                </span>
                       <span>   <FaInstagram />
                                   </span>
                       <span><FaLinkedinIn />
                                  </span>
                     </div>
                   </div>
        </div>
      </div>

      <div className="footer-fc-11-bottom">
        Sports WordPress Theme 2022 – Designed & Developed by VW Themes
      </div>
    </footer>
    <style>{`/* Dark textured background */
.sports-footer-fc-11 { margin-top:50px;
  position: relative;
  background: #0e0e12 ;
  padding: 10px 40px 40px;
  color: #fff;
  overflow: hidden;
}

/* Angled orange shapes */
.footer-fc-11-orange-left,
.footer-fc-11-orange-right {
  position: absolute;
  bottom: 0;
  width: 280px;
  height: 80px;
  background: rgba(144, 202, 249,1);
  transform: skewX(-25deg);
  z-index: 2;
}

/* SOCIAL ICONS */
.social-fc-11-row {
  margin-top: 20px;
}
.social-fc-11-icons {display:flex;justify-content:center;}

.social-fc-11-icons span {
  background: rgba(144, 202, 249,1); margin-top: 20px;display:flex;justify-content:center;align-items:center;
  color: #000;
  width:40px;height:40px;
  margin-right: 8px;
  border-radius: 4px;
  cursor: pointer;
}
.footer-fc-11-orange-left {
  left: -60px;
}

.footer-fc-11-orange-right {
  right: -60px;
  transform: skewX(25deg);
}

/* Layout */
.footer-fc-11-content {padding: 10px 40px 40px;
  display: flex;
  gap: 60px;
  z-index: 3;
  position: relative;
}

.footer-fc-11-col {
  flex: 1;
  min-width: 220px;
}

.footer-fc-11-logo {
  width: 150px;
  margin-bottom: 20px;
}

.footer-fc-11-text {
  opacity: 0.8;
  line-height: 1.6;
  margin-bottom: 20px;
}

.footer-fc-11-heading {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.footer-fc-11-item {
  opacity: 0.85;
  margin: 4px 0;
}

/* News Items */
.news-fc-11-item {
  margin-bottom: 18px;
}

.news-fc-11-category {
  background: rgba(144, 202, 249,1);
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
}

.news-fc-11-title {
  margin: 5px 0;
  font-size: 15px;
}

.news-fc-11-date {
  opacity: 0.7;
  font-size: 13px;
}

/* Bottom text */
.footer-fc-11-bottom {
  margin-top: 40px;
  text-align: center;
  opacity: 0.7;
  font-size: 14px;
}

@media (max-width: 900px) {
  .footer-fc-11-content {
    flex-direction: column;
  }

  .footer-fc-11-orange-left,
  .footer-fc-11-orange-right {
    display: none; /* Optional – remove angled shapes on mobile */
  }
}
`}</style>
    </>
  );
};

export default FooterCard11;
